import React from "react";

import ProjectCard from "../ProjectCard";

import * as styles from "./ProjectCards.module.css";

const ProjectCards = ({ props }) => {
  const { cards } = props;

  return (
    <div className={styles.projectCards}>
      {cards.map((pCard, index) => (
        <div
          key={index}
          // data-aos="zoom-in-up"
          // data-aos-duration="300"
        >
          <ProjectCard key={index} props={pCard} />
        </div>
      ))}
    </div>
  );
};

export default ProjectCards;
